import { FC } from 'react';
import styles from './leave-space.module.scss';
import Logout from '@mui/icons-material/Logout';
import { WListItemIcon, WMenuItem } from 'components/wrappers/wrapper';

interface LeaveSpaceProps {
  className?: string;
  onClick?: () => void;
}
const LeaveSpace: FC<LeaveSpaceProps> = ({ className, onClick }) => {
  const classes = `${styles.leaveSpace} ${className || ''}`.trim();
  return (
    <WMenuItem className={classes} onClick={onClick}>
      <WListItemIcon>
        <Logout fontSize="small" />
      </WListItemIcon>
      <span>Leave space</span>
    </WMenuItem>
  );
};

export default LeaveSpace;
